import { Insurance } from 'cw-backend';

export class Plan {
    id: number;
    name: string;
    insurance: Insurance[];
}